import { useEffect, useState } from "react";
import { Divider } from "staysure-component-library";

import { useAppSelector } from "@/store/hook";

import Styles from "./mta-creation-modal.module.css";

type TravelerType = {
  encryptedId: string;
  name: string;
  medical: Array<string> | undefined;
};

function MatchingTravelersListWithMedicalConditions() {
  const { attributes } = useAppSelector((state) => state.quote);
  const mtaTravelers = attributes.mtaMedicalConsent?.mtaTravelers;
  const [travelersWithConditions, setTravelersWithConditions] = useState<
    Array<TravelerType>
  >([]);

  useEffect(() => {
    if (mtaTravelers && mtaTravelers.length > 0) {
      const modeledTravelersWithMedicals = mtaTravelers?.map(
        (traveler, index) => {
          return {
            encryptedId: `${index}-${traveler.firstName}`,
            name: `${traveler.firstName} ${traveler.lastName}`,
            medical: traveler.medical?.condition.split("|"),
          };
        }
      );

      setTravelersWithConditions(modeledTravelersWithMedicals);
    }
  }, [mtaTravelers]);

  if (travelersWithConditions && travelersWithConditions.length > 0) {
    return (
      <div className={Styles.container}>
        {travelersWithConditions.map((traveler) => {
          return (
            <div key={traveler.encryptedId}>
              <span className="font-[700] text-interactive-secondary-default text-xs leading-[27px] break-words font-body-font">
                {traveler.name}
              </span>
              <ul className="text-text-functional-subtle text-2xs font-body-font font-[400] leading-[24px] break-words">
                {traveler.medical?.map((condition) => {
                  return <li key={condition}>{condition}</li>;
                })}
              </ul>
              <Divider className="bg-border-subdued" margin={12} />
            </div>
          );
        })}
      </div>
    );
  }
}

export default MatchingTravelersListWithMedicalConditions;
